<template>
  <InputPlayV3
    v-bind="$attrs"
    id="input-datetime-play"
    :mask="'##/##/#### ##:##'"
    right-icon="calendar_month"
    right-icon-clickable
    :placeholder="placeholder"
    name="input-datetime-play"
    :model-value="text"
    @right-icon-click="showDatepickerModal"
    @update:model-value="toDate"
  />
</template>

<script lang="ts" setup>
import { modal } from '@/events';
import { format, isValid, parse, parseISO } from 'date-fns';
import { ref, watch } from 'vue';
import InputPlayV3 from '../../atoms/InputPlayV3/InputPlayV3.vue';

const text = ref<string>('');

const props = withDefaults(defineProps<{
  modelValue?: Date | string | null;
  placeholder?: string;
  minDate?: Date | null | undefined;
}>(), {
  placeholder: 'Ex: 15/04/2021 15:45',
  minDate: undefined,
  modelValue: undefined,
})

watch(() => props.modelValue, (value) => {
  toText(value);
}, {
  immediate: true,
})

function toText(value: Date | string | null) {
  if (!value) {
    text.value = '';
    return;
  }
  if (typeof value === 'string') {
    value = parseISO(value);
  }
  if (value.getHours() === 0 && value.getMinutes() === 0) {
    text.value = format(value, "dd/MM/yyyy");
  } else {
    text.value = format(value, "dd/MM/yyyy HH:mm");
  }
}

function toDate(value: string) {
  text.value = value;
  if (!value) {
    emit('update:modelValue', undefined);
    return;
  }
  if (value.length == 10) {
    const date = parse(value, "dd/MM/yyyy", new Date());
    if (isValid(date)) {
      emit('update:modelValue', date);
    }
  } else if (value.length == 16) {
    const date = parse(value, "dd/MM/yyyy HH:mm", new Date());
    if (isValid(date)) {
      emit('update:modelValue', date);
    }
  }
}

const emit = defineEmits<{
  (e: 'update:modelValue', value: Date): void;
}>()


function showDatepickerModal() {
  modal.show('DatePickerModal', {
    date: props.modelValue,
    minDate: props.minDate,
    onConfirm: (data: Date) => {
      toText(data);
      emit('update:modelValue', data);
    }
  })
}

</script>
